import { TransactionDocument, TransactionDocumentsResponseDTO } from '../../entities/TransactionDocuments';

const TransactionDocumentsResponseDTOtoTransactionDocumentsAdapter = (
  response: TransactionDocumentsResponseDTO,
): TransactionDocument[] => {
  if (!response.body) {
    throw Error();
  }

  const { documents } = response.body;

  return documents.map(
    doc => new TransactionDocument(doc.referenceNumber, doc.fileName, doc.fileDescription, doc.fileSn),
  );
};

export { TransactionDocumentsResponseDTOtoTransactionDocumentsAdapter };
